<ng-container>
  <button
    type="button"
    nz-button
    nzType="link"
    (click)="expandAll(true)"
    *ngIf="!allExpanded; else collapseBtn"
  >
    {{ "BUTTON.EXPAND_ALL" | translate }}
  </button>
  <ng-template #collapseBtn>
    <button
      type="button"
      nz-button
      nzType="link"
      (click)="expandAll(false)"
      *ngIf="allExpanded"
    >
      {{ "BUTTON.COLLAPSE_ALL" | translate }}
    </button>
  </ng-template>
</ng-container>
